import React from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";

const NAVY = "#0F2C59";
const GOLD = "#D4A017";

// Direct-consumer buyer entry point (distinct from the professional "I Have a Buyer" workflow).
// Release 1: the CTA routes to an honest, feature-flagged landing (/looking-for-property).
// It never exposes a fake or broken workflow. Full Direct Buyer journey = Release 2.
export const BuyerEntryCTA = ({ testid = "buyer-entry-cta" }) => {
  const nav = useNavigate();
  return (
    <div data-testid={testid} className="rounded-2xl border border-[#D4A017]/35 bg-[#FBF3E2] p-5">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 h-10 w-10 shrink-0 rounded-full border-2 flex items-center justify-center" style={{ borderColor: GOLD }}>
          <Search className="h-5 w-5" strokeWidth={2} style={{ color: GOLD }} />
        </div>
        <div className="min-w-0">
          <h2 className="text-base font-bold" style={{ color: NAVY }}>Looking for a property?</h2>
          <p className="text-[13px] mt-1 leading-relaxed" style={{ color: "#5B6472" }}>
            Tell us what you're looking for and discover properties and professionals that match your needs.
          </p>
        </div>
      </div>
      <button
        type="button"
        data-testid={`${testid}-button`}
        onClick={() => nav("/looking-for-property")}
        className="mt-4 w-full h-11 rounded-xl font-bold flex items-center justify-center gap-2 active:scale-[0.99] transition-all hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A017]/50"
        style={{ backgroundColor: NAVY, color: GOLD }}
      >
        Post What You're Looking For <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};
